import { getState } from '/bb/state.js';
import { ensureCurrentPage } from '/bb/helpers.js';
import { finalizeOpenIntervals } from '/bb/finalize.js';
import { finalizeActiveFieldSession, syncActiveField } from '/bb/listeners/focus.js';
import { syncVisibleSections } from '/bb/listeners/sections.js';

let originalPushState = null;
let originalReplaceState = null;
let attached = false;

function onPopState() {
  handlePageTransition();
}

function handlePageTransition() {
  const t = Date.now();
  finalizeActiveFieldSession();
  finalizeOpenIntervals(getState(), t, { close: true });
  ensureCurrentPage();
  syncVisibleSections(t);
  syncActiveField(t);
}

export function attach() {
  if (attached || typeof window === 'undefined' || typeof history === 'undefined') return;
  originalPushState = history.pushState;
  originalReplaceState = history.replaceState;
  if (typeof originalPushState === 'function') {
    history.pushState = function () {
      const t = Date.now();
      finalizeActiveFieldSession();
      finalizeOpenIntervals(getState(), t, { close: true });
      const ret = originalPushState.apply(this, arguments);
      try {
        ensureCurrentPage();
        syncVisibleSections(t);
        syncActiveField(t);
      } catch (e) {
        /* ignore */
      }
      return ret;
    };
  }
  if (typeof originalReplaceState === 'function') {
    history.replaceState = function () {
      const t = Date.now();
      finalizeActiveFieldSession();
      finalizeOpenIntervals(getState(), t, { close: true });
      const ret = originalReplaceState.apply(this, arguments);
      try {
        ensureCurrentPage();
        syncVisibleSections(t);
        syncActiveField(t);
      } catch (e) {
        /* ignore */
      }
      return ret;
    };
  }
  window.addEventListener('popstate', onPopState, { passive: true });
  attached = true;
}

export function detach() {
  if (!attached || typeof window === 'undefined' || typeof history === 'undefined') return;
  if (originalPushState) history.pushState = originalPushState;
  if (originalReplaceState) history.replaceState = originalReplaceState;
  window.removeEventListener('popstate', onPopState);
  originalPushState = null;
  originalReplaceState = null;
  attached = false;
}
